module.exports = {
  className: (...classes) => {
    try {
      if (typeof classes == "object") classes = classes.flat();
      return classes.join(" ").trim();
    } catch (e) {
      console.warn("error building class name list", classes, e);
    }
  },
};
